import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=12048cfd&scoped=true&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=12048cfd&prod&lang=scss&"
import style1 from "./PaymentSuccess.vue?vue&type=style&index=1&id=12048cfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12048cfd",
  null
  
)

export default component.exports